import type { RecipeCategory } from "../types";

export const starterCategories: RecipeCategory[] = [
  {
    id: "starter-boulangerie",
    name: "Boulangerie",
    coverKey: "boulangerie",
    isFixed: true,
  },
  {
    id: "starter-dessert",
    name: "Dessert",
    coverKey: "dessert",
    isFixed: true,
  },
  {
    id: "starter-plat",
    name: "Plat",
    coverKey: "plat",
    isFixed: true,
  },
  {
    id: "starter-entree",
    name: "Entrée",
    coverKey: "entree",
    isFixed: true,
  },
  {
    id: "starter-soupe",
    name: "Soupe",
    coverKey: "soupe",
    isFixed: true,
  },
  {
    id: "starter-boisson",
    name: "Boisson",
    coverKey: "boisson",
    isFixed: true,
  },
];

export const genericCategoryCover = "/category-covers/maison.jpg";

export function normalizeCategoryName(name: string) {
  return name.trim().toLocaleLowerCase("fr").normalize("NFD").replace(/\p{Diacritic}/gu, "");
}

export function categoryCoverUrl(coverKey?: string) {
  return coverKey ? `/category-covers/${coverKey}.jpg` : genericCategoryCover;
}

export function findCategoryCover(categories: string[], catalogue: RecipeCategory[] = starterCategories) {
  const normalizedNames = categories.map(normalizeCategoryName);
  const category = catalogue.find((item) => normalizedNames.includes(normalizeCategoryName(item.name)));
  return {
    name: category?.name ?? categories[0] ?? "Recette maison",
    url: categoryCoverUrl(category?.coverKey),
  };
}
